<template>
    <div>
      <Header :active="active"></Header>
      <img :src="top_slogan" alt="" class="banner-img" />
      <div class="w1300">
        <div class="content-nav">
          <span @click="goIndex()">首页</span>> <span @click="goUrl()">{{cate_title}}</span>><span @click="goUrl()">{{children_title}}</span>><span>正文</span>
        </div>
        <div class="neirong">
          <div class="title">{{article.title}}</div>
          <div class="time">
            来源：<span v-if="article.source">{{article.source}}</span><span v-else>承德市妇联</span> &nbsp;&nbsp;&nbsp;&nbsp;
            发布时间：{{article.createTime | truncate(10)}} &nbsp;&nbsp;&nbsp;&nbsp;阅读：{{article.readNum}}</div>
          <div class="info">
            <!-- <div v-html="article.content"></div> -->
            <div class="ql-editor" v-html="article.content"></div>
          </div>
          <div class="info-bottom">
            <p v-if="article.upOne" @click="goInfo(article.upOne.id,article.upOne.url)">上一篇：{{article.upOne.title}}</p>
              <p v-if="article.downOne" @click="goInfo(article.downOne.id,article.downOne.url)">下一篇：{{article.downOne.title}}</p>
          </div>
        </div>
      </div>
      <Foot></Foot>
    </div>
  </template>
  <script>
  import Header from "../components/header.vue";
  import Foot from "../components/foot.vue";
  import "quill/dist/quill.core.css";
  export default {
    components: {
      Header,
      Foot,
    },
    data() {
      return {
        active: 1,
        cate_title:'',
        children_title:'',
        article:'',
        top_slogan:this.$imgUrl + localStorage.getItem('top_slogan')
      };
    },
    mounted(){
      let id = this.$route.params.id;
      this.cate_title = this.$route.params.cate_title;
      this.children_title = this.$route.params.children_title;
      this.info(id)
    },
    methods:{
      async info(id){
        let res = await this.$get('/web/news/details',{id:id})
        if(res.code == 200){
          this.article = res.data
        }
      },
      goInfo(id,url){
        if(url !== null && url !== undefined && url !== ""){
          window.open(url);
        }else{
          this.$router.push('/pinpaiinfo/'+id+"/"+this.cate_title+"/"+this.children_title,()=>{},()=>{})
          this.info(id)
        }
      },
      goUrl(){
        this.$router.push('/pinpaijianshe/1/'+this.article.cateId,()=>{},()=>{})
      },
      goIndex(){
      this.$router.push('/')
    }
    }
  };
  </script>
  <style scoped>
  .content-nav {
    border-bottom: solid 1px #bb030d;
    padding: 15px 0;
    font-size: 15px;
    margin-top: 15px;
    margin-bottom: 40px;
  }
  .content-nav span {
    margin-right: 10px;
    margin-left: 10px;
    color: #727272;
  }
  .banner-img{width: 1300px;margin: 0 auto;margin-top: 20px;display: block;}
  .title{text-align: center;font-size: 20px;font-weight: bold;}
  .time{color: #8a8a8a;font-size: 14px;text-align: center;margin: 20px 0;}
  .info p{color: #565656;font-size: 16px;line-height: 35px;text-indent: 2em;}
  .info-bottom{margin-top: 60px;color: #8a8a8a;font-size: 14px;}
  .info-bottom p{margin-bottom: 15px;}
  .info-bottom p:hover{cursor: pointer;}
  .content-nav span:hover{cursor: pointer;}
  </style>
  